"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useModal = void 0;
const react_1 = require("react");
const BeamContext_1 = require("../BeamContext");
const utils_1 = require("../../utils");
function useModal() {
    const { modalState, modalCanCloseChecks } = (0, BeamContext_1.useBeamContext)();
    const lastCanClose = (0, react_1.useRef)();
    const api = (0, react_1.useRef)();
    (0, react_1.useEffect)(() => {
        return () => {
            modalCanCloseChecks.current = modalCanCloseChecks.current.filter((c) => c !== lastCanClose.current);
        };
    }, [modalCanCloseChecks]);
    return (0, react_1.useMemo)(() => ({
        openModal(props) {
            // TODO Check already open?
            // TODO Check can leave?
            modalState.current = { ...props, api };
        },
        closeModal() {
            var _a;
            // TODO: Should remove checks
            for (const canCloseModal of modalCanCloseChecks.current) {
                if (!canCloseModal()) {
                    return;
                }
            }
            (0, utils_1.maybeCall)((_a = modalState.current) === null || _a === void 0 ? void 0 : _a.onClose);
            modalState.current = undefined;
        },
        // TODO: Rename as a breaking change
        addCanClose(canClose) {
            modalCanCloseChecks.current = [
                // Only allow one canClose per component at a time; this lets the caller avoid useMemo'ing their lambda
                ...modalCanCloseChecks.current.filter((c) => c !== lastCanClose.current),
                canClose,
            ];
            lastCanClose.current = canClose;
        },
        setSize(size) {
            var _a;
            if (modalState.current && ((_a = modalState.current.api) === null || _a === void 0 ? void 0 : _a.current)) {
                modalState.current.api.current.setSize(size);
            }
        },
    }), [modalState, modalCanCloseChecks]);
}
exports.useModal = useModal;
